import { defineComponent as r, openBlock as o, createBlock as n, unref as i, mergeProps as c, withCtx as s, renderSlot as l } from "vue";
import { NIcon as a } from "naive-ui";
const d = r({
  name: "HLIcon",
  inheritAttrs: !0
}), p = /* @__PURE__ */ r({
  ...d,
  props: {
    id: {
      type: String
    },
    size: {
      type: [Number, String],
      default: "16"
    },
    color: String
  },
  setup(e) {
    return (t, u) => (o(), n(i(a), c({
      id: e.id,
      class: "hr-icon-inner",
      size: e.size,
      color: e.color
    }, t.$attrs), {
      default: s(() => [
        l(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "size", "color"]));
  }
});
export {
  p as default
};
//# sourceMappingURL=highrise.es116.js.map
